import _ from "lodash";
import React, { useState, useEffect } from "react";
import IntlMessages from "util/intlMessages";
import { Alert } from "reactstrap";
import { setOnChange } from "components/special";
import { SwitchValue } from "components/special/forms";

const UserData = (props) => {
  const { user, setUser, saveUserHandler, requestHandler = new Function() } = props;
  const changeUser = setOnChange(user, setUser);
  const [error, setError] = useState(false);

  const saveUser = () => {
    const onFailure = ({ message }) => {
      setError(message);
    };
    const onRequest = () => {
      requestHandler();
      setError(false);
    };
    saveUserHandler({ body: user }, { onFailure, onRequest });
  };

  return (
    <div>
      {error && (
        <Alert className="alert-danger" isOpen="true" toggle={() => setError(false)}>
          <IntlMessages id={error} />
        </Alert>
      )}

      {/* 
      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Users.login" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="login"
            value={user.login || ""}
            onChange={changeUser}
            className="form-control react-form-input"
            autoComplete="off"
          />
        </div>
      </div>
       */}

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Users.name" />
        </label>
        <div className="col-8">
          <input
            type="text"
            name="profile.name"
            value={_.get(user, "profile.name") || ""}
            onChange={changeUser}
            className="form-control react-form-input"
            autoComplete="off"
          />
        </div>
      </div>

      {/* 
      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="Users.isAdmin" />
        </label>
        <div className="col-8  my-auto">
          <SwitchValue
            name="isAdmin"
            value={user.isAdmin}
            onChange={changeUser}
          />
        </div>
      </div>
      */}

      <div className="form-group row">
        <label className="col-4 col-form-label">
          <IntlMessages id="tables.enabled" />
        </label>
        <div className="col-8 my-auto">
          <SwitchValue value={user.enabled} onChange={changeUser} />
        </div>
      </div>

      <button
        type="button"
        onClick={saveUser}
        className="btn c-primary form-button"
      >
        <IntlMessages id={"save"} />
      </button>
    </div>
  );
};

export default UserData;
